/**
 * Represents filters for searching for users.
 */
export class UserFilter {

    /**
     *
     * @param companyId
     * @param account
     * @param role
     * @param isActive
     */
    constructor(companyId, account, role, isActive) {
        this._companyId = companyId;
        this._account = account;
        this._role = role;
        this._isActive = isActive;

    }

    /**
     * Gets the company Id
     * @returns {string}
     */
    get companyId() {
        return this._companyId;
    }

    /**
     * Gets the account
     * @returns {string}
     */
    get account() {
        return this._account;
    }

    /**
     * Gets the role.
     * @returns {string}
     */
    get role() {
        return this._role;
    }

    /**
     * Gets the isActive filter flag.
     */
    get isActive() {
        return this._isActive;
    }

}